export default __webpack_public_path__ + "static/coding-practice-56adfb110f86f356ca6735e9f1687f8f.jpeg";